import { focusAtom } from 'jotai-optics';
import { appAtom } from './appAtom';

export const customerAtom = focusAtom(appAtom, (optic) =>
  optic.prop('customer')
);
